/** @format */

import {styled} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

export const Root = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: 14,
}));

export const LabelText = styled(Typography)(({theme}) => ({
  fontSize: 14,
  color: theme.palette.semantic_dark?.surface.onSurfaceMuted,
  fontWeight: 400,
}));

interface HighlightedTextProps {
  isPositive?: boolean;
  color?: string;
}

export const HighlightedText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'isPositive' && prop !== 'color',
})<HighlightedTextProps>(({theme, isPositive, color}) => ({
  fontSize: '14px',
  color: color
    ? color
    : isPositive
      ? theme.palette.semantic_dark?.good.main
      : theme.palette.semantic_dark?.bad.main,
  marginLeft: theme.spacing(1),
  fontWeight: 700,
}));
